// extracted by mini-css-extract-plugin
module.exports = {"selection":"Selection_selection__e2pgB"};